import { Typography } from '@mui/material';
import { FC } from 'react';
import { Link } from 'react-router-dom';

interface AppLogoProps {
    isMobile?: boolean;
}

/**
 * Logo/brand component for the app bar
 */
const AppLogo: FC<AppLogoProps> = ({ isMobile = false }) => {
    return (
        <Typography
            variant="body1"
            noWrap
            component="p"
            sx={{
                mr: 2,
                display: isMobile ? { xs: 'block', md: 'none' } : { xs: 'none', md: 'block' },
                flexGrow: isMobile ? 1 : 0,
                verticalAlign: 'text-top',
                '& a': {
                    color: 'white',
                    textDecoration: 'none',
                },
                fontWeight: '700',
                fontSize: '0.875rem'

            }}
        >
            <Link to={'/'}>eventbild.se</Link>
        </Typography>
    );
};

export default AppLogo;
